export const getClassName = (config: any) =>
  config?.className === undefined
    ? "form-control"
    : `${config.className} form-control`;
